<template>
    <div id="send">
        <div v-if="isChangeAsset" @click.self="isChangeAsset = false" class="show-assets-wrapper">
            <div class="show-assets-container">
                <div class="show-assets-details-wrapper">
                    <div class="show-assets-details" v-for="(asset, index) in selectedWallet.assets"
                        @click="selectAWallet(asset)" :key="index">

                        {{ asset.name }}
                    </div>

                </div>
            </div>
        </div>
        <mt-header class="dl_header_new_bg" fixed>
            <mt-button slot="left" @click.native="$router.back()">
                <img class="go-back" src="@/assets/img/ico_back.png" />
            </mt-button>
        </mt-header>
        <div class="container">
            <div class="page-head">
                <h2 class="page-title">{{ title }}</h2>
                <mt-button @click="Flicking()">
                    <img src="@/assets/img/coinDetail/ico_saoyisao_fasong.png" alt class="sao" />
                </mt-button>
            </div>
            <div class="content">
                <div class="category" v-if="category == '云端'">
                    <mt-radio :title="$t('send.title')" align="right" v-model="transfer_type" :options="types">
                    </mt-radio>
                </div>
                <div class="address">
                    <input type="text" :placeholder="$t('coin.receive_address')" class="wx_one_ellipsis wx_fontSize3"
                        v-model="address" value="address" />
                    <img src="@/assets/img/coinDetail/ico_lianxiren_fasong.png" alt class="contact"
                        style="width: 26px" @click="addressBook(category)" />
                </div>

                <div class="address">
                    <input type="text" :placeholder="`0 ${detailCata.unit}`" class="wx_one_ellipsis wx_fontSize3"
                        style="width: 40%" v-model="amount" />
                    <span class="fuhao">≈</span>
                    <div class="change-asset" @click="showChangeAsset()">{{ detailCata.unit }}</div>

                    <span class="contact" v-if="detailCata.cloud_balance == 0">0{{ detailCata.currency_symbol }}</span>
                    <span class="contact" v-else-if="category == '云端'">{{
                            ((detailCata.price / detailCata.cloud_balance) * amount)
                            | numFilter
                    }}{{ detailCata.currency_symbol }}</span>

                    <span class="contact" v-else-if="detailCata.balance == 0">0{{ currency_char }}</span>
                    <span class="contact" v-else>{{ (((price / detailCata.balance) * amount)) || 0 }}{{ currency_char
                    }}</span>
                </div>
                <p class="tip">
                    <span class="balance wx_fontSize2" v-if="this.$route.query.category == 'HD'">{{ $t("coin.balance")
                    }} {{ detailCata.balance | numFilter
}}{{ detailCata.unit }}</span>
                    <span class="balance wx_fontSize2" v-else>{{ $t("coin.balance") }} {{ detailCata.cloud_balance |
                            numFilter
                    }}{{ coin_symbol }} {{ $t("coin.fee") }}:{{ transfer_fee }}
                        {{ detailCata }}</span>
                    <!--<span class="allSend wx_fontSize2" @click="allSend()">{{
                            $t("coin.send_all")
                    }}</span>-->
                </p>
                <div class="address">
                    <input type="text" :placeholder="$t('coin.tx_remark')" class="wx_one_ellipsis wx_fontSize3"
                        v-model="memo" />
                </div>
                <div class="mark wx_fontSize3 hidden" v-if="category == 'HD'">
                    {{ $t("coin.gas_fee") }}
                </div>

                <input type="range" name="current" class="progress hidden" :value="processPoint" :max="detailCata.high"
                    :min="detailCata.low" :step="detailCata.low / 10" id="processRange" @input="changeProcess()" :style="{
                        background:
                            '-webkit-linear-gradient(top, #1296db, #1296db) 0% 0% / ' +
                            (processPoint * 100) / detailCata.high +
                            '% 100% no-repeat',
                    }" v-if="category == 'HD'" />
                <div class="sub wx_fontSize3 hidden" v-if="category == 'HD'">
                    {{ $t("coin.slow") }}
                    <input type="submit" :value="processPoint" style="
              height: 30px;
              line-height: 10px;
              color: #8c92a8;
              background: transparent;
              width: 84%;
            " class="submitVal" />{{ $t("coin.fast") }}
                </div>
                <div class="footer wx_fontSize3" @click="getSubmit()">
                    {{ $t("coin.send") }}
                </div>
            </div>
            <div class="box" ref="box" v-show="show_pay_pwd">
                <div class="mag">
                    <mt-cell :title="$t('coin.tx_password')">
                        <span @click="close()">
                            <img src="@/assets/img/ico_close_lan.png" alt="" style="width: 20px; height: 20px" />
                        </span>
                    </mt-cell>
                    <div class="passContainer">
                        <Password ref="pay_pass" v-on:end="onEnd"></Password>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import { saoYiSaoMessage } from "@/utils/index";
import { validateEmpty } from "@/utils/validate";
import { httpGetUserInfo } from "@/api/login";
import {
    signEthTransaction,

    signBtcTransaction,
    signTrcTransaction,
    signTrcTokenTransaction,
    signBscTransaction,
    signBscTokenTransaction,
    signEthTokenTransaction
} from "@/utils/hdwallet";
import { httpCoinSend } from "@/api/hdwallet";
import { httpAccountTransfer } from "@/api/index";
import { numFilter } from "@/filters/index";
import {
    httpAccountInfo,
    httpAccountHDInfo,
    httpPrepare,
    httpHdTransactionSend,
} from "@/api/index";
import Password from "@/components/Password";
import { get } from "http";
export default {
    components: { Toast, Password },
    data: function () {
        return {
            processPoint: 0,
            coin_symbol: "",
            title: "",
            address: "",
            amount: null,
            memo: "",
            price: "",
            detailCata: "",
            category: "",
            Prepare: {},
            result: "",
            currency_char: "",
            show_pay_pwd: true,
            password: "",
            pay: true,
            types: [
                {
                    label: this.$t("send.t1"),
                    value: "1",
                },
                {
                    label: this.$t("send.t2"),
                    value: "2",
                },
            ],
            transfer_type: "1",
            transfer_fee: 0,
            isChangeAsset: false,
        };
    },
    created() {
        window.getvalueFromApp = this.getvalueFromApp;
    },
    computed: {
        hdWalletPassword: function () {
            return JSON.parse(window.LS.get("selectedWallet")).password.length > 0 ? true : false;
        },

        checkHdWalletPassword: {
            get() {
                return this.$store.getters.checkHdWalletPassword
            }
        }
    },
    mounted() {
        this.transfer_type = "1";
    },
    watch: {
        transfer_type: function (val, old) {
            if (val == "1") {
                this.transfer_fee = this.detailCata.min_fee;
            } else {
                //内部转账不需要费用
                this.transfer_fee = 0;
            }
        },
    },
    activated() {

        this.pay = true;
        this.$refs.box.style.top = "1000px";
        this.coin_symbol = this.$route.query.coin_symbol;
        if (this.$route.query.category == "HD") {
            this.detailCata = { ...this.$store.state.sendDetails }
            //httpPrepare({ coin_symbol: this.coin_symbol })
            //  .then((res) => {
            //    this.detailCata = res.data;
            //    this.processPoint = res.data.current;
            //  })
            //  .catch(() => {});

        }
        this.title = this.$t("coin.send") + " " + this.detailCata.unit;
        this.category = this.$route.query.category;
        this.price = this.$route.query.price;
        this.address = this.$route.query.addr || "";
        this.currency_char = this.$store.state.currency_char;
        this.info();
        if (this.checkHdWalletPassword) {
            this.prepareSendHd();
        }
        this.getUserInfo();
    },
    methods: {
        getUserInfo: function () {
            httpGetUserInfo()
                .then((res) => {
                    this.$store.dispatch("setUserInfo", res.data);
                })
                .catch(() => { });
        },
        changeProcess: function () {
            var range = document.getElementById("processRange");
            this.processPoint = range.value;
        },
        addressBook(title) {
            if (this.category == "云端") {
                this.$router.push({
                    path: "/addressBook",
                    query: { title: this.$t("coin.address_book1") },
                });
            } else {
                this.$router.push({
                    path: "/addressBook",
                    query: { title: this.$t("coin.address_book2") },
                });
            }
        },
        Flicking() {
            saoYiSaoMessage();
        },
        getvalueFromApp(value) {
            Toast(value);
            this.address = value;
        },
        close() {
            this.$refs.box.style.top = "1000px";
        },
        onEnd: function (val) {
            if (val.length == 6) {
                this.password = val;
                this.submitMsg();
            }
        },
        submitMsg() {
            var p = {
                transfer_type: this.transfer_type,
                coin_symbol: this.coin_symbol,
                amount: this.amount,
                to_address: this.address,
                memo: this.memo,
                // fee: this.processPoint,
                fee: this.transfer_fee,
                passWord_pay: this.password,
            };
            httpAccountTransfer(p)
                .then((res) => {
                    Toast(res.msg);
                    if (res.code == 1) {
                        this.$refs.box.style.top = "1000px";
                        this.address = "";
                        this.amount = 0;
                        this.$router.back();
                    }
                })
                .catch(() => { });
        },
        getSubmit: function () {

            if (
                validateEmpty(this.coin_symbol) ||
                validateEmpty(this.amount) ||
                validateEmpty(this.address)
            ) {
                Toast(this.$t("empty"));
                return;
            }
            if (this.category == "云端") {
                if (this.$store.state.userInfo.has_paypwd != 1) {
                    Toast(this.$t("coin.need_pay_pass"));
                    this.$router.push("/SetPayPassword");
                    return;
                }
                if (this.pay) {
                    this.$refs.box.style.top = "0px";
                    this.$refs.pay_pass.focus();
                    this.$refs.pay_pass.reset();
                } else {
                    this.submitMsg();
                }
            } else {
                if (this.hdWalletPassword) {
                    //not yet
                    this.$router.push(
                        {
                            path: "/enterHdWalletPassword",

                            query: {
                                coin_symbol: this.coin_symbol,

                                category: "HD",


                            }
                        });
                } else {
                    Toast(this.$t("coin.need_pin"));
                    return;
                }
                //this.prepareSendHd()
            }
        },
        prepareSendHd: function () {
            if (this.coin_symbol == "BTC") {
                //(input, to, value, fee)
                this.result = signBtcTransaction(
                    this.address,
                    this.amount,
                    this.detailCata.address,
                    this.detailCata.privateKey,
                    this.detailCata.precision,

                );

                if (this.result) {
                    this.send();
                }
            } else if (this.coin_symbol == "ETH") {

                if (this.detailCata.assetType == 'token') {
                    this.result = signEthTokenTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.contract_address,
                        this.detailCata.privateKey,
                        this.detailCata.precision,
                        this.detailCata.walletAddress
                    );
                } else if (this.detailCata.assetType == 'main') {
                    this.result = signEthTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.address,
                        this.detailCata.privateKey,

                    );
                }

                if (this.result) {
                    this.send();
                }
            } else if (this.coin_symbol == "BSC") {
                if (this.detailCata.assetType == 'token') {
                    this.result = signBscTokenTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.contract_address,
                        this.detailCata.privateKey,
                        this.detailCata.precision,
                        this.detailCata.walletAddress
                    );
                } else if (this.detailCata.assetType == 'main') {
                    this.result = signBscTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.address,
                        this.detailCata.privateKey
                    );
                }
                if (this.result) {
                    this.send();
                }
            } else if (this.coin_symbol == "TRX") {
                if (this.detailCata.assetType == 'token') {
                    this.result = signTrcTokenTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.contract_address,
                        this.detailCata.privateKey,
                        this.detailCata.precision
                    );
                } else if (this.detailCata.assetType == 'main') {
                    this.result = signTrcTransaction(
                        this.address,
                        this.amount,
                        this.detailCata.address,
                        this.detailCata.privateKey
                    );
                }

                if (this.result) {
                    this.send();
                }
            }

            else {
                this.result = signTokenTransaction(
                    this.detailCata.nonce,
                    this.detailCata.contract,
                    this.address,
                    this.amount,
                    this.detailCata.gas,
                    this.processPoint,
                    this.detailCata.coin_decimal
                );
                if (this.result) {
                    this.send();
                }
            }
            this.$store.dispatch('checkHdWalletPassword', false)
        },
        send() {
            var p = {
                coin_symbol: this.coin_symbol,
                amount: this.amount,
                to_address: this.address,
                memo: this.memo,
                fee: this.processPoint,
                raw: this.result,
            };
            httpHdTransactionSend(p)
                .then((res) => {
                    Toast(res.msg);
                    if (res.code == 1) {
                        this.address = "";
                        this.amount = 0;
                    }
                })
                .catch(() => { });
        },
        allSend() {
            if (this.category == "云端") {
                if (this.detailCata.cloud_balance == undefined) {
                    return "";
                }
                var str = numFilter(this.detailCata.cloud_balance - this.transfer_fee);
                if (str == undefined || str < 0 || isNaN(str)) {
                    str = 0;
                }
                this.amount = str;
            } else {
                if (this.detailCata.balance == undefined) {
                    return "";
                }
                var str = numFilter(this.detailCata.balance - this.detailCata.min_fee);
                if (str == undefined || str < 0 || isNaN(str)) {
                    str = 0;
                }
                this.amount = str;
            }
        },
        info() {
            if (this.$route.query.category == "云端") {
                httpAccountInfo({
                    coin_symbol: this.coin_symbol,
                    currency: this.$store.getters.currency,
                })
                    .then((res) => {
                        this.detailCata = res.data;

                        this.processPoint = res.data.min_fee;
                        this.transfer_fee = res.data.min_fee;
                    })
                    .catch(() => { });
            } else if (this.$route.query.category == "HD") {
                this.detailCata = { ...this.$store.state.sendDetails }
                //httpPrepare({ coin_symbol: this.coin_symbol })
                //  .then((res) => {
                //    this.detailCata = res.data;
                //    this.processPoint = res.data.current;
                //  })
                //  .catch(() => {});

            }
        },
        showChangeAsset() {
            this.isChangeAsset = true
            this.selectedWallet = JSON.parse(window.LS.get(`w-${this.detailCata.walletId}`))
        },
        selectAWallet(item) {
            this.isChangeAsset = false
            let theItem = item
            theItem.walletAddress = this.detailCata.walletAddress
            theItem.walletId = this.detailCata.walletId
            this.detailCata = theItem
            this.title = this.$t("coin.send") + " " + this.detailCata.unit;

        },

    },
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

#send {
    width: 100%;
    height: 100%;
    background-color: #f6f8fa;
    padding-top: 50px !important;
}

.go-back {
    width: 20px;
    height: 20px;
}

.page-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.page-title {
    font-size: 1.25rem;
    color: #12172e;
}

#send /deep/ .mint-button--normal {
    padding: 0 !important;
}

.container {
    padding: 0 30px;
}

.sao {
    width: 20px;
    height: 20px;
}

.content {
    background-color: #fff;
    box-shadow: 0 20px 15px 8px #dae5f0;
    padding: 20px !important;
    border-radius: 20px;
}

.address {
    height: 75px;
    line-height: 75px;
    border-bottom: 1px solid #e3e8ed;
    width: 100%;
    color: #a9afc8;
    position: relative;
}

.address input {
    width: 80%;
    height: 70px;
    /*line-height: 75px;*/
}

.fuhao {
    height: 26px;
    position: absolute;
    left: 40%;
    bottom: 20px;
    line-height: 26px;
    color: #212529;
}

.contact {
    height: 26px;
    position: absolute;
    right: 0px;
    bottom: 26px;
    line-height: 26px;
    color: #212529;
}

.change-asset {
    height: 26px;
    position: absolute;
    right: 0px;
    bottom: 2px;
    line-height: 26px;
    color: #212529;
    padding: 4px;
    border: skyblue 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
}

.tip {
    width: 100%;
    position: relative;
    margin: 10px 0;
}

.balance {
    width: 80%;
    display: inline-block;
    text-align: left;
    color: #8c92a8;
}

.allSend {
    width: 20%;
    display: inline-block;
    text-align: center;
    color: #1296db;
}

.mark {
    color: #212529;
    margin-top: 30px;
}

.content .range {
    width: 100%;
}

.sub {
    color: #8c92a8;
    margin: 0 12px;
    width: 96%;
}

.progress {
    width: 94%;
    margin-left: 3%;
    height: 40px;
}

input[type="range"] {
    /*input外壳样式*/
    -webkit-appearance: none;
    border-radius: 10px;
    height: 5px;
    z-index: 10;
    margin-top: 20px;
    margin-bottom: 20px;
}

input[type="range"]::-webkit-slider-runnable-track {
    /*轨道*/

    height: 5px;

    background: rgba(225, 225, 225, 0.2);

    border-radius: 10px;
}

input[type="range"]::-webkit-slider-thumb {
    width: 15px;
    height: 15px;
    -webkit-appearance: none;
    margin-top: -5px;

    background: #1296db;

    border-radius: 50%;
}

.footer {
    width: 80%;
    height: 50px;
    background: #2bb0e9;
    line-height: 50px;
    text-align: center;
    color: #ffffff;
    /* margin-top: 40px; */
    border-radius: 50px;
    margin: 30px auto 0;
}

.box {
    position: absolute;
    top: 800;
    left: 0;
    background: #F6F8FA;
    z-index: 5;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.mag {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #F6F8FA;
    height: 60%;
}

.swiper {
    height: 80px;
}

.swiper img {
    width: 100%;
    max-height: 100%;
    border-radius: 10px;
}

.mint-cell {
    margin: 0 30px;
    background: #F6F8FA;
}

.passContainer {
    margin: 30px;
    background-color: #fff;
    box-shadow: 0 20px 15px 8px #DAE5F0;
    padding: 20px;
    border-radius: 20px;
}




.show-assets-wrapper {
    display: flex;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1500;
    overflow: hidden;
}

.show-assets-container {
    display: flex;
    height: 300px;
    width: 100%;
    background: white;
    border-radius: 12px 12px 0 0;
    margin-top: auto;
    overflow: hidden;

}

.show-assets-chains {
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.1);
    min-width: fit-content;
    height: 100%;
    overflow-y: auto;
}

.show-assets {
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    filter: grayscale(100%);

}

.show-assets-active {
    filter: grayscale(0);

}

.show-assets-details-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
}

.show-assets-details {
    display: flex;
    width: 90%;
    margin: 10px auto;
    height: 40px;
    background: rgb(89, 77, 245);
    border-radius: 8px;
    padding-left: 8px;
    align-items: center;
    color: white;

}

.oImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.hidden {
    display: none;
}
</style>